import { useEffect, useState } from "react";
import { Box, Image, Loader, Text } from "@mantine/core";
import { surgeryCentersLabsService } from "../../../services/admin/surgeryCentersLabs.service";

interface SurgeryCenterLabLogoPreviewProps {
  logoS3Key: string | null;
  name?: string;
}

export function SurgeryCenterLabLogoPreview({
  logoS3Key,
  name,
}: SurgeryCenterLabLogoPreviewProps) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!logoS3Key) {
      setPreviewUrl(null);
      return;
    }
    let cancelled = false;
    surgeryCentersLabsService
      .getLogoDownloadUrl(logoS3Key)
      .then((url) => {
        if (!cancelled) setPreviewUrl(url);
      })
      .catch(() => {
        if (!cancelled) setPreviewUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [logoS3Key]);

  if (!logoS3Key) {
    return (
      <Box
        style={{
          width: "100%",
          height: "100%",
          background: "var(--mantine-color-gcpBlue-6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text fw={700} size="xl" c="white">
          {name?.charAt(0)?.toUpperCase() || "S"}
        </Text>
      </Box>
    );
  }
  if (!previewUrl) return <Loader size="xs" />;
  return (
    <Image
      src={previewUrl}
      alt="Surgical center logo"
      fit="contain"
      style={{ maxHeight: "100%", maxWidth: "100%" }}
      onError={() => setPreviewUrl(null)}
    />
  );
}
